/* eslint-disable no-constant-condition */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { subscriptionQuantity } from 'components/Drawers/components/VendorDetailsDrawer/constant';
import { UPDATE_USER_SUBSCRIPTION_QUANTITY } from 'pages/Vendor/VendorGraphQL';
import { indiaCallingCodeId } from 'constants';

const VendorSubscriptionQuantity = ({
  userSubscription,
  id,
  callingCodeId,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [inputEnabled, setInputEnabled] = useState(false);
  const [userSubscriptionQuantity, setUserSubscriptionQuantity] =
    useState(userSubscription);
  const [updateUserSubscription] = useMutation(
    UPDATE_USER_SUBSCRIPTION_QUANTITY,
    {
      onCompleted: ({ updateUserSubscription }) => {
        toast.success(subscriptionQuantity);
        setUserSubscriptionQuantity(updateUserSubscription);
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
      },
    },
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Only allow digits (integer values)
      setInputValue(value);
    }
  };

  const handleConfirm = () => {
    try {
      updateUserSubscription({
        variables: {
          updateInput: {
            id: userSubscription?.id,
            trader: id,
            subscriptionPlan: userSubscription?.subscriptionPlan?.id,
            dealQtyUnit: userSubscription?.dealQtyUnit,
            dealQtyLimit: inputValue,
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
    setInputEnabled(false);
    setInputValue('');
  };

  const handleCancel = () => {
    setInputEnabled(false);
    setInputValue('');
  };

  return (
    <>
      {/* {userSubscription?.dealQtyLimit > 0 ? (
        <span
          className="f-14 font-inter d-block text-dark"
          onClick={() => {
            setInputEnabled(true);
          }}
          // disabled={userSubscription?.isTrial}
        >
          {`${userSubscription?.dealQtyLimit} ${userSubscription?.dealQtyUnit} Remaining`}
        </span>
      ) : inputEnabled ? (
        <div className="d-flex align-items-center ">
          <input
            value={inputValue}
            type="number"
            name="dealQtyLimit"
            onChange={handleInputChange}
            placeholder="Enter quantity"
            className="form-control"
          />
          <Button
            className="btn btn-success ms-2 p-1"
            onClick={handleConfirm}
            disabled={!inputValue} // Disable if inputValue is empty
          >
            ✓
          </Button>
          <Button className="btn btn-danger ms-2 p-1" onClick={handleCancel}>
            ✕
          </Button>
        </div>
      ) : (
        <span
          className="f-14 font-inter d-block text-dark"
          onClick={() => {
            setInputEnabled(true);
          }}
          // disabled={userSubscription?.isTrial}
        >
          {userSubscriptionQuantity?.dealQtyLimit
            ? `${userSubscription?.dealQtyLimit} ${userSubscription?.dealQtyUnit} Remaining`
            : 'UNLIMITED'}
        </span>
      )} */}
      {inputEnabled ? (
        <>
          <div className="d-flex align-items-center ">
            <input
              value={inputValue}
              type="number"
              name="dealQtyLimit"
              onChange={handleInputChange}
              placeholder="Enter quantity"
              className="form-control"
            />

            <Button
              className="btn btn-success ms-2 p-0 rounded-circle w-30"
              onClick={handleConfirm}
              disabled={
                !inputValue ||
                inputValue >
                  (callingCodeId === indiaCallingCodeId ? 5000000 : 5000) ||
                inputValue <= 0
              }
            >
              ✓
            </Button>
            <Button
              className="btn btn-danger ms-2 p-0 rounded-circle w-30"
              onClick={handleCancel}
            >
              ✕
            </Button>
          </div>
          {(inputValue >
            (callingCodeId === indiaCallingCodeId ? 5000000 : 5000) ||
            inputValue <= 0) && (
            <div className="text-danger f-12">
              {inputValue >
              (callingCodeId === indiaCallingCodeId ? 5000000 : 5000)
                ? `Deal Quantity Limit cannot exceed ${
                    callingCodeId === indiaCallingCodeId
                      ? '50,00,000 KG'
                      : '5,000 MT'
                  } `
                : 'Deal Quantity Limit cannot be less than or equal to 0'}
            </div>
          )}
        </>
      ) : (
        <div
          className="f-14 font-inter d-block text-dark cursor-pointer text-primary"
          // disabled={userSubscription?.isTrial}
          onClick={() => {
            if (userSubscription?.isTrial) setInputEnabled(true);
          }}
        >
          {userSubscriptionQuantity?.dealQtyLimit >= 0
            ? `${userSubscriptionQuantity?.dealQtyLimit} ${userSubscriptionQuantity?.dealQtyUnit} Remaining`
            : 'UNLIMITED'}
        </div>
      )}
    </>
  );
};

export default VendorSubscriptionQuantity;
